export const INITIALIZE_SERVICE_WORKER = 'INITIALIZE_SERVICE_WORKER'
export const UPDATE_SERVICE_WORKER = 'UPDATE_SERVICE_WORKER'
